import * as React from "react";
import { Navigate } from "react-router-dom";
import { OutletContextProps } from "../../helpers/RouterHelper";
import { isStudentFollowSummaryAccessible } from "../../helpers/StudentFollowSummaryHelper";
import enhanceSectionsPage from "../../hocs/enhanceSectionsPage";
import SectionInterface from "../../interfaces/SectionInterface";
import SectionsStudentFollowPrompt from "./SectionsStudentFollowPrompt";

interface Props extends OutletContextProps {
  section: SectionInterface;
}

const SectionsStudentFollowPromptPage = ({ section, setActiveMenu }: Props) => {
  // section は enhanceSectionsPage がロード済みを保証
  const accessible = isStudentFollowSummaryAccessible(section);

  React.useEffect(() => {
    if (accessible) {
      setActiveMenu("student_follow_summary");
    }
  }, [accessible]);

  // ACC-02: aiAssistantAvailable が false の校舎からの直接 URL アクセスをブロックする
  if (!accessible) {
    return <Navigate to={`/sections/${section.id}`} replace />;
  }

  return <SectionsStudentFollowPrompt section={section} />;
};

export default enhanceSectionsPage(SectionsStudentFollowPromptPage, {
  title: "プロンプト設定",
});
